module.exports = __webpack_public_path__ + "img/horizontal-slogan-white.ec383028.svg";